import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import { withStyles } from '@material-ui/core/styles';


//TODO: use another method to get the store state, such as in
//https://stackoverflow.com/questions/35667249/accessing-redux-state-in-an-action-creator
import store from '../../../store';
import ProjectHeader from './ProjectHeader';
import ProjectMetrics from './ProjectMetrics';
import ProjectSchedule from './ProjectSchedule';
import InvoiceTabs from './InvoiceTabs';
import ScheduleTabs from './ScheduleTabs';

const styles = theme => ({
  root: {
    margin: '20px',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    flexBasis: '1000px',
    minHeight: '500px',
  },
  projectTabs: {
    width: '120px',
    display: 'flex',
  },
  scheduleContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexGrow: 1,
  },
});

//TODO: Project should be reserved for a specific type of Job/Task, rename Project
//to something more meaningful so that the Project vs Maintenance distinction
//can be preserved
class ProjectCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      schedule: undefined
    };
  }

  componentDidMount() {
    const project = this.props.project;
    let scheduleItem;

    if (project.isRecurring) {
      const currentDate = new Date();
      scheduleItem = project.schedule.find((scheduleItem) => {
        return scheduleItem.date.getFullYear() === currentDate.getFullYear();
      })
    } else {
      scheduleItem = project.schedule[0];
    }

    this.setState({
      schedule: scheduleItem
    });
  }

  handleScheduleSelect(scheduleItem) {
    this.setState({schedule: scheduleItem});
  }

  render() {
    const { schedule } = this.state;
    const { classes, project } = this.props;
    const scheduleDate = schedule === undefined ? undefined : schedule.scheduleDate;

    //TODO: remove horrible hack to get invoice data in:
    //1. don't get state through singleton store or it will be harder to render server side
    //2. don't compare dates this way
    //3. simplify/reduce the logical conditions
    //4. move into componentDidMount and in the change schedule function(todo still)
    //5 use moment for dates, also getYear() is deprecated(getFullYear instead)
    const invoice = store.getState().invoicesState.find( function(invoice){
      const invoiceDate = new Date(invoice.invoiceDate);

      //if maintentance job then get invoice by date
      //else then a project and use intervalId
      if (project.isRecurring){
        if (scheduleDate !== undefined){
          if (invoice.projectId !== project.id) return false;
          if (invoiceDate.getMonth() !== scheduleDate.getMonth()) return false;
          if (invoiceDate.getYear() !== scheduleDate.getYear()) return false;

          return true;
        } else {
          return false;
        }
      } else {
        if (schedule !== undefined && schedule.intervalId === invoice.intervalId) {
          return true;
        } else {
          return false;
        }
      }

    });


    return(
        <Card className={classes.root}>
          <ProjectHeader project={project} />
          <Paper className={classes.content} elevation={5}>
            <div className={classes.projectTabs}>
              {project.isRecurring &&
                <ScheduleTabs project={project} selectedItem={this.state.schedule} handleSelect={this.handleScheduleSelect.bind(this)} />
              }
              {!project.isRecurring &&
                <InvoiceTabs project={project} selectedItem={this.state.schedule} handleSelect={this.handleScheduleSelect.bind(this)} />
              }
            </div>
            <Paper className={classes.scheduleContent}>
              { schedule && project &&
                <ProjectSchedule project={project} invoice={invoice} schedule={schedule} />
              }
              <ProjectMetrics project={project} />
            </Paper>
          </Paper>
        </Card>
    );
  }
}


ProjectCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProjectCard);



// WEBPACK FOOTER //
// ./src/components/admin/Project/ProjectCard.jsx